<template>
  <div>
    <div>
      <v-row no-gutters align="center">
        <v-col cols="12" md="5">
          <div class="pa-2">
            <v-card style="background-color: #016443; padding: 2px">
              <v-text-field
                placeholder="Search Schedule"
                solo
                v-model="find"
                hide-details
                dense
                prepend-inner-icon="mdi-magnify"
                flat
              ></v-text-field>
            </v-card>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <div class="pa-2">
            <v-select
              background-color="#016443"
              dense
              hide-details
              :items="optStatus"
              item-text="txt"
              item-value="val"
              v-model="typeContent"
              placeholder="Sort by"
              solo
              dark
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="pa-2 d-flex align-center">
            <v-menu
              v-model="showPickerStart"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startTime"
                  prepend-inner-icon="mdi-calendar-range"
                  readonly
                  v-on="on"
                  hide-details
                  dense
                  outlined
                  solo
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startTime"
                @input="closeStartDate"
              ></v-date-picker>
            </v-menu>
            <h2>&nbsp;-&nbsp;</h2>
            <v-menu
              v-model="showPickerEnd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endTime"
                  prepend-inner-icon="mdi-calendar-range"
                  readonly
                  v-on="on"
                  hide-details
                  dense
                  outlined
                  solo
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endTime"
                :allowed-dates="allowedDates"
                @input="closeEndDate"
              ></v-date-picker>
            </v-menu>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <div class="pa-2">
            <v-btn
              block
              depressed
              color="#016443"
              dark
              class="mr-2 px-2"
              @click="fetchData"
            >
              <h5>Search</h5>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8">
          <div class="pa-2">
            <div class="pa-1">
              <div v-if="!loading && dataSet">
                <v-card
                  v-for="(item, n) in dataSet"
                  :key="n"
                  class="pa-8 mb-3 rounded-lg"
                  flat
                >
                  <div class="d-flex align-start">
                    <v-avatar class="mr-3">
                      <img :src="ava" class="obj_fit" alt="" />
                    </v-avatar>
                    <div class="ml-2">
                      <div class="d-flex align-center">
                        <h4 style="color: #006341">
                          {{ item.data_user.name }} - Facilitator
                        </h4>
                        <h5 class="ml-2" style="color: #a2aaad">
                          added meeting
                        </h5>
                      </div>
                      <small
                        style="
                          font-weigth: normal;
                          color: rgba(162, 170, 173, 0.5);
                        "
                      >
                        {{ $date(item.created_at).fromNow() }}</small
                      >
                    </div>
                  </div>
                  <div class="mt-2">
                    <h4 style="color: #006341">{{ item.title }}</h4>
                    <!-- <div class="" v-if="item.description">
                      <span
                        v-if="!readMoreActivated && item.description.length > 200"
                        >{{ item.description.slice(0, 200) }}</span
                      >
                      <a
                        v-if="!readMoreActivated && item.description.length > 200"
                        @click="activateReadMore"
                      >
                        read more...
                      </a>
                      <span
                        v-if="readMoreActivated || item.description.length < 200"
                        v-html="item.description"
                      ></span>
                    </div> -->
                  </div>
                  <div class="mt-2">
                    <h4 style="color: #006341">Time</h4>
                    <div class="d-flex align-center justify-space-between">
                      <div class="mr-2">
                        <h4>Start</h4>
                        <h4 style="font-weight: normal">
                          {{
                            $date(item.start_section.fake.start_date).format(
                              "dddd, DD MMMM YYYY",
                            )
                          }}
                        </h4>
                        <h4 style="font-weight: normal">
                          {{ item.start_section.fake.start_time }}
                        </h4>
                      </div>
                      <v-divider
                        style="background-color: black"
                        vertical
                      ></v-divider>
                      <div class="mx-2">
                        <h4>End</h4>
                        <h4 style="font-weight: normal">
                          {{
                            $date(item.end_section.fake.end_date).format(
                              "dddd, DD MMMM YYYY",
                            )
                          }}
                        </h4>
                        <h4 style="font-weight: normal">
                          {{ item.end_section.fake.end_time }}
                        </h4>
                      </div>
                      <v-divider
                        style="background-color: black"
                        vertical
                      ></v-divider>
                      <div class="ml-2">
                        <h4 style="color: #006341">Additional Info</h4>
                        <div class="d-flex align-center justify-space-between">
                          <div>
                            <h4>{{ item.media }}</h4>
                            <a
                              :href="item.additional_info"
                              target="_blank"
                              style="color: #006341"
                              >Link Zoom</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
              </div>
              <div v-if="loading">
                <v-skeleton-loader
                  type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                ></v-skeleton-loader>
              </div>
              <div
                class="empty d-flex align-center justify-center flex-column"
                v-if="!loading && dataSet.length == 0"
              >
                <img
                  src="../../../../assets/img/redaksi/pagenotfound.png"
                  height="150px"
                  alt=""
                />
                <b class="default_txt my-3">
                  There are no schedule who have submitted yet
                </b>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="4">
          <v-card flat class="pa-4">
            <div class="mt-3" v-if="!loading && dataScholar.length > 0">
              <v-row
                no-gutters
                v-for="(item, n) in dataScholar"
                :key="n"
                class="my-2"
                align="center"
              >
                <v-col cols="3">
                  <router-link
                    class="opener_name"
                    :to="`/scholar/${item.data_scholar.user_id}`"
                  >
                    <v-avatar class="mr-3">
                      <img
                        :src="
                          item.data_scholar.profile_picture
                            ? item.data_scholar.profile_picture
                            : ava
                        "
                        class="obj_fit"
                        alt=""
                      />
                    </v-avatar>
                  </router-link>
                </v-col>

                <v-col cols="7">
                  <div>
                    <router-link
                      class="opener_name"
                      :to="`/scholar/${item.data_scholar.user_id}`"
                    >
                      <h5 class="notBold black--text">
                        {{ item.data_scholar ? item.data_scholar.name : "-" }}
                      </h5>
                    </router-link>
                    <h5 class="notBold" style="color: rgba(0, 0, 0, 0.4)">
                      {{ item.data_scholar ? item.data_scholar.no_tf : "-" }}
                    </h5>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div v-if="!loading && dataScholar.length == 0">
              <div class="my-1 align-center justify-center d-flex flex-column">
                <img
                  src="../../../../assets/img/redaksi/pagenotfound.png"
                  height="100px"
                  alt=""
                />
                <b class="default_txt mt-3">Data not found</b>
              </div>
            </div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar, ist-item-three-line"
            ></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <dialog-large
      :d_large="d_large"
      @refetch="fetchData"
      @close="d_large = false"
      :inventory="inventory"
      :type="d_type"
      :title="d_title"
    />
    <dialog-small
      :d_small="d_small"
      @refetch="fetchData"
      @close="d_small = false"
      :inventory="inventory"
      :type="d_type"
      :title="d_title"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
// import DialogLarge from "../../../dialog/dialogLarge.vue";
import DialogSmall from "../../../dialog/dialogSmall.vue";
export default {
  name: "listScheduleScholarFacilitator",
  props: ["courseName", "viewType"],
  computed: {
    ...mapState({
      id: (state) => state.id,
      ava: (state) => state.ava,
    }),
  },
  components: { DialogSmall },
  data() {
    return {
      loading: true,
      optStatus: [
        { txt: "Sort by newest", val: "-updated_at" },
        { txt: "Sort by oldest", val: "updated_at" },
      ],
      typeContent: "-updated_at",
      showPickerStart: false,
      startTime: "",
      showPickerEnd: false,
      endTime: "",
      find: "",
      dataSet: null,
      dataScholar: null,
      readMoreActivated: false,
      d_large: false,
      inventory: "",
      d_type: "",
      d_title: "",
      d_small: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let tempPath = `schedule?filter[title]=${this.find}&sort=${this.typeContent}&include=dataUser&type=fasilitator&course_id=${this.$route.params.idCourse}`;
      if (this.startTime && this.endTime) {
        tempPath = `schedule?start_date=${this.startTime}&end_date=${this.endTime}&filter[title]=${this.find}&sort=${this.typeContent}&include=dataUser&type=fasilitator&course_id=${this.$route.params.idCourse}`;
      }
      let data = {
        path: tempPath,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.dataSet.forEach((item) => {
            item.start_section = {
              ori: item.start_section,
              fake: {
                start_date: this.$date(item.start_section).format("YYYY-MM-DD"),
                start_time: this.$date(item.start_section).format("HH:MM"),
              },
            };
            item.end_section = {
              ori: item.end_section,
              fake: {
                end_date: this.$date(item.end_section).format("YYYY-MM-DD"),
                end_time: this.$date(item.end_section).format("HH:MM"),
              },
            };
          });
          this.fetchDataScholar();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchDataScholar() {
      let cekPath = `course/fasilitator?page[number]=${this.page}&page[size]=${this.limit}&sort=-created_at&include=dataFasilitator,dataScholar&filter[search]=${this.find}&filter[user_id]=${this.$route.params.idFacilitator}`;
      if (!this.viewType) {
        cekPath = `course/fasilitator?page[number]=${this.page}&page[size]=${this.limit}&sort=-created_at&include=dataFasilitator,dataScholar&filter[search]=${this.find}`;
      }
      let data = {
        path: cekPath,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataScholar = data.data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    closeStartDate(item) {
      this.showPickerStart = false;
      this.startTime == item ? item : "";
    },
    closeEndDate(item) {
      this.showPickerEnd = false;
      this.endTime == item ? item : "";
    },
    allowedDates(val) {
      return val >= this.startTime.substr(0, 10);
    },
    activateReadMore() {
      this.readMoreActivated = true;
    },
    createSchedulue() {
      this.inventory = { courseName: this.courseName };
      this.d_type = "c_schedule";
      this.d_title = "Add Meeting";
      this.d_large = true;
    },
    deleteSchedule(item) {
      this.d_type = "d_schedule";
      this.d_title = "Delete Data";
      this.d_small = true;
      item["d_width"] = "300px";
      this.inventory = item;
    },
    updateSchedule(item) {
      let data = {
        data: item,
        courseName: this.courseName,
      };
      this.d_type = "u_schedule";
      this.d_title = "Update Data";
      this.d_large = true;
      this.inventory = data;
    },
  },
};
</script>

<style></style>
